export const GeneralCookieSettings = {
  name: 'empori-cookies-accepted',
  value: 'accepted',
  liteTime: 365
};

export function GetCookie (cookieName: string) {
  const name = cookieName + '=';
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return true;
    }
  }

  return false;
}

export function SetCookie (cookieName: string, cookieValue: string, expiryDays: number) {
  const date = new Date();
  date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));

  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
}